import Index from './Locations'
import IndexHeading from './IndexHeading'
import CreateHeading from './CreateHeading'
import EditHeading from './EditHeading'
import Form from './Form'

export default {
  Index,
  IndexHeading,
  EditHeading,
  CreateHeading,
  Form
}



// WEBPACK FOOTER //
// ./src/components/locations/index.js